const InternalsModule = () => import('@pages/internals/InternalsModule')
const HomePage = () => import('@pages/internals/home/HomePage')
const ManagementModule = () => import('@pages/internals/management/InternalManagementModule')
const CommunicationsModule = () => import('@pages/internals/communications/InternalCommunicationsModule.vue')
const NewsletterInternals = () => import('@pages/communications/newsletters/NewsletterInternals')
const InternalCouncilPage = () => import('@pages/internals/management/InternalCouncilIndex')
const InternalCouncilMeetings = () => import('@pages/internals/management/InternalCouncilMeetings')
const InternalCouncilDocuments = () => import('@pages/internals/management/InternalCouncilDocuments')
const FacilityBookingIndexPage = () => import('@pages/facilities/InternalFacilityIndex')
const FaultsIndex = () => import('@pages/faults/FaultsIndex')
// const AccessAuthorizationsIndex = () => import('@pages/internals/accessAuthorizations/Index')
import AccessAuthorizationsIndex from '@pages/internals/accessAuthorizations/Index'
const UploadAccessAuthorizations = () => import('@pages/internals/accessAuthorizations/UploadAccessAuthorizations')
const EmergencyContactsIndex = () => import('@pages/internals/emergencyContacts/Index')
const VideoTutorials = () => import('@pages/internals/videoTutorials/Index')

export default {
    path: 'internals',
    component: InternalsModule,
    children: [
        {
            path: 'home',
            component: HomePage,
            name: 'internalsHomePage',
        },
        {
            path: 'management',
            component: ManagementModule,
            children: [
                {
                    path: 'iternal-council',
                    component: InternalCouncilPage,
                    name: 'internalCouncilPage',
                },
                {
                    path: 'meetings',
                    component: InternalCouncilMeetings,
                    name: 'internalCouncilMeetings',
                },
                {
                    path: 'documents',
                    component: InternalCouncilDocuments,
                    name: 'internalCouncilDocuments',
                },
                {
                    path: 'facility-booking',
                    component: FacilityBookingIndexPage,
                    name: 'facilityBookingIndex',
                },
                {
                    path: 'newsletter-internals',
                    component: NewsletterInternals,
                    name: 'newsletterInternals',
                },
                {
                    path: 'faults-index',
                    component: FaultsIndex,
                    name: 'faultsIndex',
                },
                {
                    path: 'access-authorizations',
                    component: AccessAuthorizationsIndex,
                    name: 'accessAuthorizations',
                },
                {
                    path: 'upload-access-authorizations',
                    component: UploadAccessAuthorizations,
                    name: 'uploadAccessAuthorizations',
                },
                {
                    path: 'emergency-contacts',
                    component: EmergencyContactsIndex,
                    name: 'emergencyContacts',
                },
            ],
        },
        { path: 'video-tutorials', component: VideoTutorials, name: 'videoTutorials' },
    ],
}
